module.exports = __webpack_public_path__ + "static/img/bd.5f60257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bd.png
// module id = XDbO
// module chunks = 29